module.exports = __webpack_public_path__ + "88289724b2adf6693723a50b506b47dc.png";